import { useEffect, useState } from 'react';
import './App.scss';
import {useNavigate, useLocation} from 'react-router-dom';
import Header from '../containers/Header';
import Navbar from '../containers/Navbar';
import {Layout} from '../containers/Layout';
import Footer from '../containers/Footer';

import { useAutoScrollOnVisit } from '../components/hooks/useAutoScrollOnVisit';
import { useLoginModal, LoginModalProvider } from '../contexts/LoginModalContext';
import { ToastContainer } from '../contexts/ToastNotification';
import { LoginModalWrapper } from '../components/modules/Wrapper/LoginModalWrapper';
import CookieBanner from '../components/modules/cookies/CookieBanner';
import CookiePreferencesModal from '../components/modules/cookies/CookiePreferencesModal';

function AppContent() {
    const location = useLocation();
    const navigate = useNavigate();
    const { openLoginModal } = useLoginModal();
    const [componentHidden, setComponentHidden] = useState(false);
    const [headerHidden, setHeaderHidden] = useState(false);
    const [isCookieModalOpen, setIsCookieModalOpen] = useState(false); // ← Stato per modal cookie

   // ✅ Auto-scroll ottimizzato con easing dolce
    useAutoScrollOnVisit({
        enabled: true,
        delay: 100,
        easing: 'easeOutCubic' 
    });

    // ✅ Ascolta i parametri URL per la verifica email
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const verified = urlParams.get('verified');
        const email = urlParams.get('email');
        
        if (verified === 'true' && email) {
            // Pulisci URL
            window.history.replaceState({}, document.title, window.location.pathname);
            
            console.log('📧 Verifica rilevata! Email:', email);
            
            // Apri modal login dopo 1 secondo
            setTimeout(() => {
                openLoginModal('login');
            }, 1000);
        }
    }, [navigate, openLoginModal]);

    useEffect(() => {
        const handleOpenCookieModal = () => {
            setIsCookieModalOpen(true);
        };
        
        window.addEventListener('openCookiePreferences', handleOpenCookieModal);
        
        return () => {
            window.removeEventListener('openCookiePreferences', handleOpenCookieModal);
        };
    }, []);

    useEffect(() => {
        const path = location.pathname;
        const isAdmin = path.includes('admin');
        const isProfile = path.includes('profile');

        setComponentHidden(isAdmin); // cache le composant si admin
        setHeaderHidden(isProfile);  // cache le header si profile
    }, [location.pathname]);

    return (
        <main>
            {!componentHidden && !headerHidden && <Header/>}
            {!componentHidden && <Navbar/>}
            <Layout/>
            {!componentHidden && (
                <Footer 
                    onOpenCookieModal={() => setIsCookieModalOpen(true)} // ← Passa la funzione al footer
                />
            )}
            
             {/* Modal cookie */}
            <CookiePreferencesModal 
                isOpen={isCookieModalOpen}
                onClose={() => setIsCookieModalOpen(false)}
                onSave={() => console.log('Preferenze cookie salvate')}
            />
        </main>
    );
}

// App principale
function App() {
    return (
        <LoginModalProvider>
            <ToastContainer />
            <CookieBanner />
            <AppContent />
            <LoginModalWrapper />
        </LoginModalProvider>
    );
}
export default App;

